import { Box, Flex, Heading, Text, UnorderedList } from '@chakra-ui/react'
import { useScreen } from '@hb/react'
import { Bold, PageContainer } from '@hb/react-web'
import {
  LegalDocument,
  LegalDocumentSection,
  LegalDocumentSectionContent,
  LegalDocumentSectionContentText,
} from '@hb/shared'

const LegalDocumentSectionContentTextView = ({
  content,
}: {
  content: LegalDocumentSectionContentText
}) => (
  <Text fontFamily="Open Sans">
    {content.title ? <Bold>{content.title} </Bold> : null}
    {content.content}
  </Text>
)

const LegalDocumentSectionContentView = ({ content }: { content: LegalDocumentSectionContent }) => {
  switch (content.type) {
    case 'text':
      return <LegalDocumentSectionContentTextView content={content} />
    case 'list':
      return (
        <UnorderedList py={2} gap={2}>
          {content.items.map(item => (
            <LegalDocumentSectionContentTextView content={item} />
          ))}
        </UnorderedList>
      )
  }
}

const LegalDocumentSectionView = ({ section }: { section: LegalDocumentSection }) => (
  <Box pb={4}>
    <Text as="h2" fontFamily="Open Sans" fontWeight="bold" color="gray.900" fontSize="lg" mb={2}>
      {section.title}
    </Text>
    {section.content.map(content => (
      <LegalDocumentSectionContentView content={content} />
    ))}
  </Box>
)

export const LegalDocumentView = ({ document }: { document: LegalDocument }) => {
  const { isMobile } = useScreen()
  return (
    <PageContainer p={0} contentProps={{ pt: isMobile ? 0 : 4 }}>
      <Flex w="100%" flexFlow="column" bg="gray.50" px={isMobile ? 6 : 10} py={6}>
        <Heading as="h1" fontSize="2rem" fontWeight={500} mb={4} fontFamily="Open Sans">
          {document.title}
        </Heading>
        {document.sections.map(section => (
          <LegalDocumentSectionView section={section} />
        ))}
      </Flex>
    </PageContainer>
  )
}
